import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative -z-0 flex items-center gap-3 max-w-7xl w-full mx-auto p-10 mt-20" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-3 aspect-square rounded-full bg-red-600" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "opacity-0 overscroll-none overflow-hidden lg:opacity-100 transition-opacity pointer-events-none absolute -z-10 -left-[45%] -top-[300%] w-[140%] aspect-square rounded-full bg-white" }, null, -1)

import LogoSmallSvg from "./LogoSmallSvg.vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(LogoSmallSvg, { class: "w-20" }),
    _hoisted_2,
    _hoisted_3
  ]))
}
}

})